import { Flex, FlexProps } from 'rebass';
import React from 'react';

export type FormColumnProps = FlexProps & {
  children: React.ReactNode;
};

const FormColumn = (props: FormColumnProps): JSX.Element => {
  return (
    <Flex
      flexDirection="column"
      mt={3}
      className="form-column"
      {...(props as any)}
      sx={{
        '>.form-column:first-of-type': {
          mt: 0,
        },
        ...props.sx,
      }}
    >
      {props.children}
    </Flex>
  );
};

export default FormColumn;
